<template>
  <div class="ms-input ms-editor w-100">
    <div
      class="text-box border"
      :class="{
        error: errorProvider.isValid,
        disabled: disabled,
        readOnly: readOnly,
      }"
    >
      <div class="tags-list">
        <span class="tags-list-item" v-for="(item, index) in value" :key="index">
          <span class="tags-text">{{ item }}</span>
          <i
            class="tags-text__close el-icon-close icon24 close"
            v-if="!readOnly"
            @click="remove(index)"
          ></i>
        </span>
        <input
          ref="input"
          type="text"
          class="tags-input ms-input-item flex"
          v-model="internalText"
          :placeholder="placeholder"
          :disabled="disabled"
          :readonly="readOnly"
          :maxlength="maxLength"
          :class="{ disabled: disabled }"
          v-on="listeners"
        />
        <div class="tutorial" :class="{ hidden: checkTutorial }" v-if="tutorial && !readOnly">
          {{ tutorial }}
        </div>
      </div>
    </div>
    <div class="flex-row">
      <div
        class="icon24 warning error-icon"
        v-show="errorProvider.isValid && isShowText"
        :title="errorProvider.message"
      ></div>
      <div class="error-text" v-if="errorProvider.isValid && isShowText">
        {{ errorProvider.message }}
      </div>
    </div>
  </div>
</template>
<script>
import msBaseComponent from "@/components/msbase/msBaseComponent.vue";
export default {
  name: "msInputMulti",
  extends: msBaseComponent,
  props: {
    /**
     * V-model bắn ra ngoài binding 2 chiều
     */
    value: {
      default: () => [],
    },
    // Nhãn của input (Đây là input nhập nội dung gì)
    label: {
      default: null,
      type: String,
    },
    /**
     * Hiện thị chũ mờ ở dưới ô input
     */
    placeholder: {
      default: null,
      type: [Number, String],
    },
    /**
     * Hiển thị title trên input
     * */
    title: {
      default: null,
      type: String,
    },
    //input chỉ đọc không cho nhập
    readOnly: {
      default: false,
      type: Boolean,
    },
    //Giới hạn nhập của ô input
    maxLength: {
      default: null,
      type: Number,
    },
    //Disable hay không
    disabled: {
      default: false,
      type: Boolean,
    },
    //Hiện thị báo lỗi text mặc định hay ko
    isShowText: {
      default: true,
      type: Boolean,
    },
    //Giới hạn số lượng tag
    tagLimit: {
      default: null,
      type: Number,
    },
    //Text hiển thị ở cuối input
    tutorial: {
      default: null,
      type: String,
    },
  },
  computed: {
    listeners() {
      return {
        input: (e) => {
          this.onInput(e);
        },
        blur: (e) => {
          this.onBlur(e);
        },
        focus: (e) => {
          this.onFocus(e);
        },
        change: (e) => {
          this.$emit("change", null);
        },
        keydown: (e) => {
          this.onKeyDown(e);
        },
      };
    },
  },
  data() {
    return {
      internalText: "",
      checkTutorial: false,
    };
  },
  created() {
    const me = this;
    if (me.tagLimit && me.value.length >= me.tagLimit) {
      me.checkTutorial = true;
      me.readOnly = true;
    }
  },
  methods: {
    //Reset lại giá trị về ban đầu
    reset() {
      const me = this;
      me.internalText = null;
    },
    //Sự kiện nhập vào ô
    onInput(e) {
      const me = this;
      if (e.target.value.trim()) {
        me.$nextTick(() => {
          this.validate(this);
        });
        let input = me.$el.querySelector(".tags-input");
        let tutorial = me.$el.querySelector(".tutorial");
        if (
          (input.offsetWidth - tutorial.offsetWidth > 0 &&
            input.offsetWidth - tutorial.offsetWidth < e.target.selectionStart) ||
          input.offsetWidth - tutorial.offsetWidth < 0
        ) {
          me.checkTutorial = true;
        } else {
          me.checkTutorial = false;
        }
      } else {
        me.errorProvider.isValid = false;
      }
    },
    //Sự kiện focus vào ô input
    onFocus(e) {
      const me = this;
      me.focused = true;
      me.$emit("focus", e);
    },
    //Sự kiên blur ra ngoài ô input
    onBlur(e) {
      const me = this;
      me.focused = false;
      me.$emit("blur", e);
    },
    /**
     * Thêm mới tag
     * CreatedBy: tmquy (09/03/2022)
     */
    onKeyDown(e) {
      if (
        e.keyCode == 13 &&
        (!this.errorProvider.isValid || this.validateEmail(this.internalText.trim())) && //Custom theo validate mong muôn ở đây
        this.tagLimitCheck()
      ) {
        this.errorProvider.isValid = false;
        //Enter
        if (!this.internalText.trim()) return;
        if (this.internalText.trim() == ",") {
          return;
        }
        this.internalText = this.internalText.replace(",", "");
        const isNotExist = this.value.every((item) => {
          return item != this.internalText;
        });
        if (isNotExist) {
          this.value.push(this.internalText.replace(",", "").trim());
          this.reset();
        }
        this.$emit("change", this.internalText);
      }
    },
    /**
     * Kiểm tra giới hạn tag
     * CreatedBy: tmquy (09/03/2022)
     */
    tagLimitCheck() {
      const me = this;
      if (me.tagLimit && me.value && me.value.length >= me.tagLimit) {
        me.$set(me.errorProvider, "message", `Chỉ được nhập tối đa ${me.tagLimit} ${me.title} `);
        me.$set(me.errorProvider, "isValid", true);
        me.errorProvider.element = me.$refs.input;
        return false;
      }
      return true;
    },
    /**
     * Xóa tag
     * CreatedBy: tmquy (09/03/2022)
     */
    remove(index) {
      this.value.splice(index, 1);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal, oldVal) {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/components/msInputMulti.scss";
</style>
